import React, { useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import { makeStyles } from '@material-ui/core/styles'
import { TextField, Button, Grid, Paper, CircularProgress } from '@material-ui/core'
import { forgotPassword } from '../services/users/forgotPassword'
import logo from '../Files/entelai-doc.svg'

const REACT_APP_CLIENT_ID_CAPTCHA = process.env.REACT_APP_CLIENT_ID_CAPTCHA

const useStyles = makeStyles((theme) => ({
  root: {
    alignItems: "center",
    marginTop: '10%',
  },
  paper: {
    width: "25%",
    borderRadius: "3%",
    boxShadow: "0 2px 5px",
    margin: "0 auto",
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
}));

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [isCaptchaValid, setIsCaptchaValid] = useState(false)
  const [sended, setSended] = useState(false)

  const handleForgotPassword = async () => {
    setLoading(true)
    if (email){
      try {
        const {data, status} = await forgotPassword(email, window.location.origin)
        if (status === 200) {
          if (data.status !== ''){
            alert('El correo fue enviado (por favor revise tambien la carpeta de correos no deseados)')
            setLoading(false)
            setSended(true)
          } else{
            alert('Por favor revise el correo electronico')
            setLoading(false)
          }
        } else{
          throw new Error()
        }
      } catch (error) {
        alert('Hubo un problema al intentar enviar el correo electronico.')
        setEmail('')
        setLoading(false)
      }
    } else{
      alert('Ingrese su correo electronico')
      setLoading(false)
    }
  }

  const classes = useStyles();

  return (
    <>
      <div className={classes.root}>
        <Grid container direction="column" alignItems="center" justifyContent="center" >
          <Paper className={classes.paper}>
            <Grid item xs={12}>
              <img src={logo} alt='Entelai Edoc' width="100%" />
            </Grid>
            {!sended ? <Grid>
              <Grid item xs={12}>
                <TextField name="email" label="Correo Electronico" variant="outlined" type="mail" fullWidth style={{marginTop: '12px'}} value={email} onChange={({target}) => setEmail(target.value)}/>
              </Grid>
              <Grid item xs={12}>
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '12px'}}>
                  <ReCAPTCHA size='normal' sitekey={REACT_APP_CLIENT_ID_CAPTCHA} onChange={(value) => setIsCaptchaValid(value)} />
                </div>
              </Grid>
              <Grid item xs={12}>
                <Button variant="outlined" color="secondary" style={{marginTop: '12px', width: '100%'}} onClick={() => window.location.replace('/login')}>
                  CANCELAR
                </Button>
                {loading && <CircularProgress style={{marginTop: '12px', marginLeft: '44%'}}/>}
                {!loading && <Button disabled={!isCaptchaValid} variant="contained" color="primary" style={{marginTop: '12px', width: '100%'}} onClick={async () => { await handleForgotPassword() }}>
                  Enviar Correo
                </Button>}
              </Grid>
            </Grid> : <p style={{margin: '12px', fontFamily: 'Roboto'}}>Te hemos enviado un correo electrónico con instrucciones para volver a establecer tu contraseña.</p>}
          </Paper>
        </Grid>
      </div>
    </>
  );
}
